module.exports = __webpack_public_path__ + "img/part-four-thumb_mobile.772e625.jpg";